<template>
  <div v-if="historyRecord.id !== currentExpense.id" class="expense-history-record">
    <div class="summary">
      <div class="icon-container" @click="isOpen = !isOpen">
        <div class="icon">
          <font-awesome-icon icon="calendar-alt" />
        </div>
      </div>
      <div class="description" @click="isOpen = !isOpen">
        <div class="modified-comment">
          {{ $t('expense.history.version', { num }) }} -
          {{ historyRecord.approverComment }}
        </div>
        <div class="modified-info">
          Modified by
          {{ historyRecord.createdBy | nameFromUserObject }} at
          {{ historyRecord.createdAt | formatDateTime }}
        </div>
      </div>
      <div class="actions-and-status">
        <div>
          <Status :status="historyRecord.status" object-type="expense" />
        </div>
        <!--
          Keep for now. In case users request feature in future
        <div>
          <TolButton
            :label="$t('expense.actions.saveAsPdf')"
            button-type="minor"
            icon-name="copy"
            @click="saveAsPdf()"
          />
        </div>
        -->
        <div @click="isOpen = !isOpen">
          <font-awesome-icon :icon="isOpen ? 'minus-square' : 'plus-square'" />
        </div>
      </div>
    </div>
    <div v-show="isOpen" class="details">
      <ExpenseDetailsTable :expense="historyRecord" :can-edit="false" />
    </div>
  </div>
</template>

<script>
import Status from '@/app/components/Status';
import ExpenseDetailsTable from './ExpenseDetailsTable';

export default {
  name: 'ExpenseHistoryRecord',
  components: { Status, ExpenseDetailsTable },
  props: {
    historyRecord: {
      type: Object,
      required: true
    },
    num: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    currentExpense() {
      return this.$store.state.expensesState.expenseDetailsState.currentExpense;
    }
  },
  methods: {
    saveAsPdf() {
      alert('pdf is not implemented yet');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.expense-history-record {
  .summary {
    padding: 20px $details-padding;
    display: flex;
    justify-content: space-between;

    > * {
      flex: 0 1 auto;
    }

    .icon-container {
      padding-right: 20px;

      .icon {
        color: $primary-blue-2;
        background: $mid-blue;
        padding: 10px;
        line-height: 10px;
        font-size: 15px;
        border-radius: 50%;
      }
    }

    .description {
      flex: 1 1 100%;

      .modified-comment {
        font-weight: bold;
      }

      .modified-info {
        font-style: italic;
        color: $grey;
      }
    }

    .actions-and-status {
      white-space: nowrap;

      > * {
        display: inline-block;
        padding: 0 20px;
      }

      > *:last-child {
        padding-right: 0;
        border-right: none;
      }
    }
  }

  .details {
    padding-bottom: $details-padding;
  }
}
</style>
